import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

Vue.use(VueRouter)

const dynamicLoadComponent = (pcComponent, wapComponent) => {
  return (resolve) => {
    if (store.state.device.isPC) {
      require([`@/views/${pcComponent}.vue`], resolve)
    } else {
      require([`@/views/${wapComponent}.vue`], resolve)
    }
  }
}

const routes = [
  // 首页
  {
    path: '/',
    name: 'home',
    component: dynamicLoadComponent('pc/HomeView', 'wap/HomeView')
  },
  // 列表页
  {
    path: '/products/:category',
    name: 'products',
    component: dynamicLoadComponent('pc/ListView', 'wap/ListView')
  },
  // 产品详情页
  {
    path: '/products/detail/:id',
    name: 'detail',
    component: dynamicLoadComponent('pc/ProductDetail', 'wap/ProductDetail')
  },
  // 会议页- webinar
  {
    path: '/webinar',
    name: 'webinar',
    component: dynamicLoadComponent('pc/WebinarView', 'wap/WebinarView')
  },
  // 会议页- event
  {
    path: '/event',
    name: 'event',
    component: dynamicLoadComponent('pc/EventView', 'wap/EventView')
  },
  // 搜索页
  {
    path: '/search',
    name: 'search',
    component: dynamicLoadComponent('pc/SearchView', 'wap/SearchView')
  },
  // Resource Library
  {
    path: '/meetings/resource',
    name:'resource',
    component: dynamicLoadComponent('page/resource', 'page/resource')
  },
  // APEX Flex on Demand
  {
    path: '/apex/index',
    name:'apex',
    component: dynamicLoadComponent('page/apex', 'page/apex')
  },
  // 中小型企业解决方案
  {
    path: '/small-business-solutions/index',
    name:'smallBusinessSolutions',
    component: dynamicLoadComponent('page/smallBusinessSolutions', 'page/smallBusinessSolutions')
  },
  // 产品促销页面
  {
    path: '/campaign/special-offer',
    name:'specialOffer',
    component: dynamicLoadComponent('page/specialOffer', 'page/specialOffer')
  },
  // 下载资料活动
  {
    path: '/downloads/index',
    name:'downloads',
    component: dynamicLoadComponent('page/downloads', 'page/downloads')
  },
  // 数据安全月
  {
    path: '/campaign/cyber-awareness-month',
    name:'cyberAwarenessMonth',
    component: dynamicLoadComponent('page/cyberAwarenessMonth', 'page/cyberAwarenessMonth')
  },
  // HK Premier
  {
    path: '/campaign/hk-premier-form',
    name:'hkPremierForm',
    component: dynamicLoadComponent('page/hkPremierForm', 'page/hkPremierForm')
  },
  // 404
  {
    path: '*',
    name: '404',
    component: dynamicLoadComponent('pc/HomeView', 'wap/HomeView')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  }
})

export default router
